import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiKey } from 'common/types/Entities';

import { handleListFetch } from '../apiHelpers';

import { APIApiKeyPost, APIGetApiKeysBySuite,APIKeyDelete } from './ApiKeys.api';

export const fetchApiKeys = createAsyncThunk('apiKeys/fetchApiKeys', async (item: { id: string, signal?: AbortSignal }) => {
    const response = await APIGetApiKeysBySuite(item);
    return formatApiKeys(response.data);
});

export const postApiKey = createAsyncThunk('apiKeys/postApiKey', async (item: { name: string, suiteId: string }) => {
    const response = await APIApiKeyPost(item);
    const rows = formatApiKeys(await handleListFetch(APIGetApiKeysBySuite( { id: item.suiteId } )));
    return {
        item,
        response,
        rows
    };
});

export const deleteApiKey = createAsyncThunk('apiKeys/deleteApiKey', async (item: { name: string, id: string }) => {
    const response = await APIKeyDelete(item);
    const rows = formatApiKeys(await handleListFetch(APIGetApiKeysBySuite( { id: item.id } )));
    return {
        item,
        response,
        rows
    };
});

const formatApiKeys = (rows: ApiKey[]) => {
    return rows.map(({ name, value }) => ({
        'id': name,
        'name': name,
        'value': value + '*****'
    }));
};
